export const loadFontFace = async (family, source) => {
  const face = new FontFace(family, source);
  await face.load();
  document.fonts.add(face);
  return face;
};

export const removeFontFace = (face) => {
  if (face) {
    document.fonts.delete(face);
  }
};

export const removeFontFamily = (family) => {
  [...document.fonts].filter((face) => face.family.replace(/"/g, '') === family).forEach(removeFontFace);
};

export const stripFontExtension = (fileName) => String(fileName || '').replace(/\.(ttf|ttc|otf|sfnt|woff2?|eot)$/i, '');
